import React from "react";
import { Route, Routes } from "react-router-dom";
import Role from "../Pages/Setting/Roles/Role";
import CreateRole from "../Pages/Setting/Roles/CreateRole";
import EditRole from "../Pages/Setting/Roles/EditRole";
import Privilege from "../Pages/Setting/Privilege/Privilege";
import CreatePrivilege from "../Pages/Setting/Privilege/CreatePrivilege";
import EditPrivilege from "../Pages/Setting/Privilege/EditPrivilege";
import TypeMaster from "../Pages/Setting/TypeMaster/TypeMaster";
import CreateTypeMaster from "../Pages/Setting/TypeMaster/CreateTypeMaster";
import EditTypeMaster from "../Pages/Setting/TypeMaster/EditTypeMaster";
import TypeMasterCategory from "../Pages/Setting/TypeMasterCategory/TypeMasterCategory";
import CreateTypeMasterCategory from "../Pages/Setting/TypeMasterCategory/CreateTypeMasterCategory";
import EditTypeMasterCategory from "../Pages/Setting/TypeMasterCategory/EditTypeMasterCategory";
import SalesOrder from "../Pages/SalesOrder/SalesOrder";
import CreateSalesOrder from "../Pages/SalesOrder/CreateSalesOrder";
import EditSalesOrder from "../Pages/SalesOrder/EditSalesOrder";
import Client from "../Pages/Client/Client";
import CreateClient from "../Pages/Client/CreateClient";
import EditClient from "../Pages/Client/EditClient";
import BOM from "../Pages/BOM/BOM";
import CreateBOM from "../Pages/BOM/CreateBOM";
import EditBOM from "../Pages/BOM/EditBOM";
import Product from "../Pages/Product/Product";
import CreateProduct from "../Pages/Product/CreateProduct";
import EditProduct from "../Pages/Product/EditProduct";
import WorkOrder from "../Pages/WorkOrder/WorkOrder";
import CreateWorkOrder from "../Pages/WorkOrder/CreateWorkOrder";
import EditWorkOrder from "../Pages/WorkOrder/EditWorkOrder";
import BO from "../Pages/BO/BO";
import EditBO from "../Pages/BO/EditBO";
import CreateBO from "../Pages/BO/CreateBO";
import StockTransaction from "../Pages/StockTransaction/StockTransaction";
import StockLedger from "../Pages/StockLedger/StockLedger";
import StockOnboarding from "../Pages/StockOnboarding/StockOnboarding";
import Error from "../ErrorPages/Error";
import NotFound from "../ErrorPages/NotFound";
import secureLocalStorage from "react-secure-storage";
import WorkOrderSplit from "../Pages/WorkOrder/WorkOrderSplit";
import DailyPlan from "../Pages/DailyPlan/DailyPlan";
import Supplier from "../Pages/Supplier/Supplier";
import CreateSupplier from "../Pages/Supplier/CreateSupplier";
import EditSupplier from "../Pages/Supplier/EditSupplier";
import Machine from "../Pages/Machine/Machine";
import CreateMachine from "../Pages/Machine/CreateMachine";
import EditMachine from "../Pages/Machine/EditMachine";
import ClientItemAssociation from "../Pages/ClientItemAssociation/ClientItemAssociation";
import CreateClientItemAssociation from "../Pages/ClientItemAssociation/CreateClientItemAssociation";
import EditClientItemAssociation from "../Pages/ClientItemAssociation/EditClientItemAssociation";
import SupplierItemAssociation from "../Pages/SupplierItemAssociation/SupplierItemAssociation";
import CreateSupplierItemAssociation from "../Pages/SupplierItemAssociation/CreateSupplierItemAssociation";
import EditSupplierItemAssociation from "../Pages/SupplierItemAssociation/EditSupplierItemAssociation";
import QualityRules from "../Pages/QualityRules/QualityRules";
import CreateQualityRules from "../Pages/QualityRules/CreateQualityRules";
import EditQualityRules from "../Pages/QualityRules/EditQualityRules";
import QualityRuleAssociation from "../Pages/QualityRuleAssociation/QualityRuleAssociation";
import CreateQualityRuleAssociation from "../Pages/QualityRuleAssociation/CreateQualityRuleAssociation";
import EditQualityRuleAssociation from "../Pages/QualityRuleAssociation/EditQualityRuleAssociation";
import QualityParameter from "../Pages/QualityParameters/QualityParameter";
import CreateQualityParameter from "../Pages/QualityParameters/CreateQualityParameter";
import EditQualityParameter from "../Pages/QualityParameters/EditQualityParameter";
import Operator from "../Pages/Operator/Operator";
import CreateOperator from "../Pages/Operator/CreateOperator";
import EditOperator from "../Pages/Operator/EditOperator";
import DailyProductionReport from "../Pages/DailyProductionReport/DailyProductionReport";
import CreateDailyProductionReport from "../Pages/DailyProductionReport/CreateDailyProductionReport";
import EditDailyProductionReport from "../Pages/DailyProductionReport/EditDailyProductionReport";
import MachineStatus from "../Pages/MachineStatus/MachineStatus";
import CreateMachineStatus from "../Pages/MachineStatus/CreateMachineStatus";
import EditMachineStatus from "../Pages/MachineStatus/EditMachineStatus";
import QC from "../Pages/QC/QC";
import QualityCheckSelection from "../Pages/QC/QualityCheckSelection";
import QualitySampleSize from "../Pages/QC/QualitySampleSize";
import ItemParameterAssociation from "../Pages/ItemParameterAssociation/ItemParameterAssociation";
import CreateItemParameterAssociation from "../Pages/ItemParameterAssociation/CreateItemParameterAssociation";
import EditItemParameterAssociation from "../Pages/ItemParameterAssociation/EditItemParameterAssociation";
import QualityCheckResults from "../Pages/QualityCheckResults/QualityCheckResults";
import CreateQualityCheckResults from "../Pages/QualityCheckResults/CreateQualityCheckResults";
import EditQualityCheckResults from "../Pages/QualityCheckResults/EditQualityCheckResults";
import SamplingPlan from "../Pages/SamplingPlan/SamplingPlan";
import CreateSamplingPlan from "../Pages/SamplingPlan/CreateSamplingPlan";
import EditSamplingPlan from "../Pages/SamplingPlan/EditSamplingPlan";
import PurchaseOrder from "../Pages/PurchaseOrder/PurchaseOrder";
import CreatePurchaseOrder from "../Pages/PurchaseOrder/CreatePurchaseOrder";
import EditPurchaseOrder from "../Pages/PurchaseOrder/EditPurchaseOrder";
import RaiseRequisition from "../Pages/Requisition/RaiseRequisition";
import IssueSlip from "../Pages/Requisition/IssueSlip";
import QCParameterSelection from "../Pages/QC/QCParameterSelection";
import Inventory from "../Pages/Inventory/Inventory";
import DeliveryStatus from "../Pages/DeliveryStatus/DeliveryStatus";
import ItemStatus from "../Pages/Product/ItemStatus";
import QCReports from "../Pages/QC/QCReports";
import MachineDetailedStatus from "../Pages/MachineStatus/MachineDetailedStatus";
import QCReportSelect from "../Pages/QC/QCReportSelect";
import Dashboard from "../Pages/Dashboard/Dashboard";
import DashboardDetailedView from "../Pages/Dashboard/DashboardDetailedView";
import QCReportDetails from "../Pages/QC/QCReportDetails";
import QCPreviousReports from "../Pages/QC/QCPreviousReports";
import DailyProduction from "../Pages/DailyProduction/DailyProduction";
import DailyProductionEdit from "../Pages/DailyProduction/DailyProductionEdit";
import BOMDetails from "../Pages/BOM/BOMDetails";
import RVMatrix from "../Pages/Setting/RV/RVMatrix";
import UpdatedRVMatrix from "../Pages/Setting/RV/UpdatedRVMatrix";
import RVAnalytics from "../Pages/Setting/RV/RVAnalytics";
import WorkOrderRMStatus from "../Pages/WorkOrder/WorkOrderRMStatus";
import WOSplit from "../Pages/WorkOrder/WOSplit";
import POEditRedirect from "../Pages/PurchaseOrder/POEditRedirect";
import DispatchForm from "../Pages/Dispatch/DispatchForm";
import Dispatch from "../Pages/Dispatch/Dispatch";
import DispatchUpdate from "../Pages/Dispatch/DispatchUpdate";
import StatisticsDashboard from "../Pages/StatisticsDashboard/StatisticsDashboard";
import MachineShiftAssociation from "../Pages/MachineShiftAssociation/MachineShiftAssociation";
import BatchInsights from "../Pages/Requisition/BatchInsights";
import MachineOperatorAssociation from "../Pages/MachineOperatorAssociation/MachineOperatorAssociation";
import QCDetails from "../Pages/QC/QCDetails";
import IssueSlipUpdated from "../Pages/Requisition/IssueSlipUpdated";
import MachineDashboard from "../Pages/Machine/dashboard/Dashboard";
import WorkOrderSplitUpdate from "../Pages/WorkOrder/WorkOrderSplitUpdate";
import SimulateBOM from "../Pages/BOM/SimulateBOM";
import SalesOrderInsights from "../Pages/SalesOrder/Insights/SalesOrderInsights";
import DispatchUpdated from "../Pages/Dispatch/DispatchUpdated";
import DispatchDetails from "../Pages/Dispatch/DispatchDetails";
import RaiseRequisitionStoreView from "../Pages/Requisition/UpdatedStoreView/table";
import IssueSlipStore from "../Pages/Requisition/UpdatedStoreView/issue-slip-store";
import SalesOrderInsightsDetails from "../Pages/SalesOrder/Insights/SalesOrderInsightsDetails";
import SupportDashboard from "../Pages/Machine/support-dashboard/dashboard";
import BatchInsightsDetails from "../Pages/Requisition/BatchInsightsDetails";
import ReturnedSlipTable from "../Pages/Requisition/ReturnedSlip/returned-slip-table";
import ReturnedSlipDetails from "../Pages/Requisition/ReturnedSlip/returned-slip-details";
import PowerConsumptionDashbarod from "../Pages/PowerConsumption/dashboard";
import BridgeConsole from "../Pages/BridgeConsole/BridgeConsole";
import Reports from "../Pages/Reports/Reports";
import NotificationConsole from "../Pages/NotificationConsole/NotificationConsole";
import LiveSite from "../Pages/Setting/LiveSite/LiveSite";
import TestCases from "../Pages/Setting/TestCases/TestCases";
import OnsiteIssueMachines from "../Pages/Setting/OnsiteIssues/OnsiteIssueMachines";
import OnsiteIssueList from "../Pages/Setting/OnsiteIssues/OnsiteIssueList";
import {
    CreateOnsiteIssue,
    EditOnsiteIssue,
} from "../Pages/Setting/OnsiteIssues/OnsiteIssueForm";
import FloorData from "../Pages/FloorData/FloorData";
// import DispatchForm from "../Pages/Supplier/DispatchForm";

const Content = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const bridgeConsolePrivileges = [
        "bridge_console",
        "bridge_console_audit_logs",
        "bridge_console_error_logs",
        "bridge_console_roles",
        "bridge_console_notifications",
        "bridge_console_notification_config",
    ];
    const canViewBridgeConsole =
        bridgeConsolePrivileges.some((privilege) =>
            privileges.includes(privilege)
        );
    const canViewNotificationConsole =
        privileges.includes("bridge_console_notifications") ||
        privileges.includes("bridge_console_notification_config");
    const canViewLiveSite =
        privileges.includes("live_site_retrieve") ||
        privileges.includes("live_site_update");
    const canViewTestCases = privileges.includes("test_case");
    const canViewOnsiteIssues = privileges.includes("onsite_issue");
    const canViewFloorData = privileges.includes("floor_data_retrieve");
    return (
        <>
            <div className="nk-content nk-content-fluid">
                <div className="container-xl wide-xl">
                    <div className="nk-content-body">
                        <Routes>
                            {privileges.includes("statistics_dashboard") ? (
                                <Route
                                    path="/"
                                    element={<StatisticsDashboard />}
                                />
                            ) : (
                                <Route path="/" element={<NotFound />} />
                            )}
                            {privileges.includes("sales_order_retrieve") ? (
                                <Route
                                    path="/sales-order"
                                    element={<SalesOrder />}
                                />
                            ) : (
                                <Route
                                    path="/sales-order"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("sales_order_create") ? (
                                <Route
                                    path="/create-sales-order"
                                    element={<CreateSalesOrder />}
                                />
                            ) : (
                                <Route
                                    path="/create-sales-order"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("sales_order_update") ? (
                                <Route
                                    path="/edit-sales-order"
                                    element={<EditSalesOrder />}
                                />
                            ) : (
                                <Route
                                    path="/edit-sales-order"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("sales_order_dispatch") ? (
                                <Route
                                    path="/dispatch-sales-order"
                                    // element={<Dispatch />}
                                    element={<DispatchUpdated />}
                                />
                            ) : (
                                <Route
                                    path="/dispatch-sales-order"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes(
                                "sales_order_dispatch_create"
                            ) ? (
                                <Route
                                    path="/dispatch-sales-order-create"
                                    element={<DispatchForm />}
                                />
                            ) : (
                                <Route
                                    path="/dispatch-sales-order-create"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes(
                                "sales_order_dispatch_update"
                            ) ? (
                                <Route
                                    path="/dispatch-sales-order-update"
                                    element={<DispatchUpdate />}
                                />
                            ) : (
                                <Route
                                    path="/dispatch-sales-order-update"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("daily_plan") ? (
                                <Route
                                    path="/daily-plan"
                                    element={<DailyPlan />}
                                />
                            ) : (
                                <Route
                                    path="/daily-plan"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes(
                                "machine_shift_association"
                            ) ? (
                                <Route
                                    path="/machine-shift-association"
                                    element={<MachineShiftAssociation />}
                                />
                            ) : (
                                <Route
                                    path="/machine-shift-association"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("raise_purchase_order") ? (
                                <Route
                                    path="/purchase-order"
                                    element={<PurchaseOrder />}
                                />
                            ) : (
                                <Route
                                    path="/purchase-order"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("purchase_order_create") ? (
                                <Route
                                    path="/create-purchase-order"
                                    element={<CreatePurchaseOrder />}
                                />
                            ) : (
                                <Route
                                    path="/create-purchase-order"
                                    element={<NotFound />}
                                />
                            )}

                            {privileges.includes("purchase_order_update") ? (
                                <Route
                                    path="/edit-purchase-order"
                                    element={<EditPurchaseOrder />}
                                />
                            ) : (
                                <Route
                                    path="/edit-purchase-order"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("purchase_order_update") ? (
                                <Route
                                    path="/edit-purchase-order-redirect"
                                    element={<POEditRedirect />}
                                />
                            ) : (
                                <Route
                                    path="/edit-purchase-order-redirect"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("delivery_status") ? (
                                <Route
                                    path="/delivery-status"
                                    element={<DeliveryStatus />}
                                />
                            ) : (
                                <Route
                                    path="/delivery-status"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("item_status") ? (
                                <Route
                                    path="/item-status"
                                    element={<ItemStatus />}
                                />
                            ) : (
                                <Route
                                    path="/item-status"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("daily_production") ? (
                                <Route
                                    path="/daily-production"
                                    element={<DailyProduction />}
                                />
                            ) : (
                                <Route
                                    path="/daily-production"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("daily_production_edit") ? (
                                <Route
                                    path="/daily-production-edit"
                                    element={<DailyProductionEdit />}
                                />
                            ) : (
                                <Route
                                    path="/daily-production-edit"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("raise_requisition") ? (
                                <Route
                                    path="/raise-requisition"
                                    element={<RaiseRequisition />}
                                />
                            ) : (
                                <Route
                                    path="/raise-requisition"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("job-cards") ? (
                                <Route
                                    path="/job-cards"
                                    element={<Dashboard />}
                                />
                            ) : (
                                <Route
                                    path="/job-cards"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("job-cards-details") ? (
                                <Route
                                    path="/job-cards-details"
                                    element={<DashboardDetailedView />}
                                />
                            ) : (
                                <Route
                                    path="/job-cards-details"
                                    element={<NotFound />}
                                />
                            )}

                            {privileges.includes("view_slip") ? (
                                <Route
                                    path="/issue-slip"
                                    // element={<IssueSlip />}
                                    element={<IssueSlipUpdated />}
                                />
                            ) : (
                                <Route
                                    path="/issue-slip"
                                    element={<NotFound />}
                                />
                            )}

                            {privileges.includes("qc_screen") ? (
                                <Route path="/qc" element={<QC />} />
                            ) : (
                                <Route path="/qc" element={<NotFound />} />
                            )}
                            {privileges.includes("qc_screen") ? (
                                <Route
                                    path="/item-selection"
                                    element={<QualityCheckSelection />}
                                />
                            ) : (
                                <Route
                                    path="/item-selection"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("qc_screen") ? (
                                <Route
                                    path="/sample-size"
                                    element={<QualitySampleSize />}
                                />
                            ) : (
                                <Route
                                    path="/sample-size"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("qc_screen") ? (
                                <Route
                                    path="/select-parameters"
                                    element={<QCParameterSelection />}
                                />
                            ) : (
                                <Route
                                    path="/select-parameters"
                                    element={<NotFound />}
                                />
                            )}
                            {/* To-Do: Add privilege */}
                            {privileges.includes("qc_report") ? (
                                <Route
                                    path="/qc-report-select"
                                    element={<QCReportSelect />}
                                />
                            ) : (
                                <Route
                                    path="/qc-report-select"
                                    element={<NotFound />}
                                />
                            )}
                            {/* To-Do: Add privilege */}
                            {privileges.includes("qc_report") ? (
                                <Route
                                    path="/qc-report"
                                    element={<QCReports />}
                                />
                            ) : (
                                <Route
                                    path="/qc-report"
                                    element={<NotFound />}
                                />
                            )}
                            {/* To-Do: Add privilege */}
                            {privileges.includes("qc_report") ? (
                                <Route
                                    path="/qc-report-details"
                                    element={<QCReportDetails />}
                                />
                            ) : (
                                <Route
                                    path="/qc-report-details"
                                    element={<NotFound />}
                                />
                            )}
                            {/* To-Do: Add privilege */}
                            {privileges.includes("qc_previous_report") ? (
                                <Route
                                    path="/qc-previous-report-select"
                                    element={<QCPreviousReports />}
                                />
                            ) : (
                                <Route
                                    path="/qc-previous-report-select"
                                    element={<NotFound />}
                                />
                            )}

                            {privileges.includes("inventory") ? (
                                <Route
                                    path="/inventory"
                                    element={<Inventory />}
                                />
                            ) : (
                                <Route
                                    path="/inventory"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("client_retrieve") ? (
                                <Route path="/client" element={<Client />} />
                            ) : (
                                <Route path="/client" element={<NotFound />} />
                            )}
                            {privileges.includes("client_create") ? (
                                <Route
                                    path="/create-client"
                                    element={<CreateClient />}
                                />
                            ) : (
                                <Route
                                    path="/create-client"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("client_update") ? (
                                <Route
                                    path="/edit-client"
                                    element={<EditClient />}
                                />
                            ) : (
                                <Route
                                    path="/edit-client"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("bom_retrieve") ? (
                                <Route path="/bom" element={<BOM />} />
                            ) : (
                                <Route path="/bom" element={<NotFound />} />
                            )}
                            {privileges.includes("bom_create") ? (
                                <Route
                                    path="/create-bom"
                                    element={<CreateBOM />}
                                />
                            ) : (
                                <Route
                                    path="/create-bom"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("bom_update") ? (
                                <Route path="/edit-bom" element={<EditBOM />} />
                            ) : (
                                <Route
                                    path="/edit-bom"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("bom_details") ? (
                                <Route
                                    path="/bom-details"
                                    element={<BOMDetails />}
                                />
                            ) : (
                                <Route
                                    path="/bom-details"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("item_retrieve") ? (
                                <Route path="/item" element={<Product />} />
                            ) : (
                                <Route path="/item" element={<NotFound />} />
                            )}
                            {privileges.includes("item_create") ? (
                                <Route
                                    path="/create-item"
                                    element={<CreateProduct />}
                                />
                            ) : (
                                <Route
                                    path="/create-item"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("item_update") ? (
                                <Route
                                    path="/edit-item"
                                    element={<EditProduct />}
                                />
                            ) : (
                                <Route
                                    path="/edit-item"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("work_order_split") ? (
                                <Route
                                    path="/sales-work-order"
                                    element={<WorkOrderSplit />}
                                    // element={<WOSplit />}
                                />
                            ) : (
                                <Route
                                    path="/sales-work-order"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("work_order_split") ? (
                                <Route
                                    path="/split-work-order"
                                    element={<WorkOrderSplitUpdate />}
                                    // element={<WOSplit />}
                                />
                            ) : (
                                <Route
                                    path="/split-work-order"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("work_order_check") ? (
                                <Route
                                    path="/requirement-analysis"
                                    element={<WorkOrderRMStatus />}
                                />
                            ) : (
                                <Route
                                    path="/requirement-analysis"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("work_order_retrieve") ? (
                                <Route
                                    path="/work-order"
                                    element={<WorkOrder />}
                                />
                            ) : (
                                <Route
                                    path="/work-order"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("work_order_create") ? (
                                <Route
                                    path="/create-work-order"
                                    element={<CreateWorkOrder />}
                                />
                            ) : (
                                <Route
                                    path="/create-work-order"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("work_order_update") ? (
                                <Route
                                    path="/edit-work-order"
                                    element={<EditWorkOrder />}
                                />
                            ) : (
                                <Route
                                    path="/edit-work-order"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("supplier_retrieve") ? (
                                <Route
                                    path="/supplier"
                                    element={<Supplier />}
                                />
                            ) : (
                                <Route
                                    path="/supplier"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("supplier_create") ? (
                                <Route
                                    path="/create-supplier"
                                    element={<CreateSupplier />}
                                />
                            ) : (
                                <Route
                                    path="/create-supplier"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("supplier_update") ? (
                                <Route
                                    path="/edit-supplier"
                                    element={<EditSupplier />}
                                />
                            ) : (
                                <Route
                                    path="/edit-supplier"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("machine_retrieve") ? (
                                <Route path="/machine" element={<Machine />} />
                            ) : (
                                <Route path="/machine" element={<NotFound />} />
                            )}
                            {privileges.includes("machine_create") ? (
                                <Route
                                    path="/create-machine"
                                    element={<CreateMachine />}
                                />
                            ) : (
                                <Route
                                    path="/create-machine"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("machine_update") ? (
                                <Route
                                    path="/edit-machine"
                                    element={<EditMachine />}
                                />
                            ) : (
                                <Route
                                    path="/edit-machine"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("client_item_retrieve") ? (
                                <Route
                                    path="/client-item"
                                    element={<ClientItemAssociation />}
                                />
                            ) : (
                                <Route
                                    path="/client-item"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("client_item_create") ? (
                                <Route
                                    path="/create-client-item"
                                    element={<CreateClientItemAssociation />}
                                />
                            ) : (
                                <Route
                                    path="/create-client-item"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("client_item_update") ? (
                                <Route
                                    path="/edit-client-item"
                                    element={<EditClientItemAssociation />}
                                />
                            ) : (
                                <Route
                                    path="/edit-client-item"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("supplier_item_retrieve") ? (
                                <Route
                                    path="/supplier-item"
                                    element={<SupplierItemAssociation />}
                                />
                            ) : (
                                <Route
                                    path="/supplier-item"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("supplier_item_create") ? (
                                <Route
                                    path="/create-supplier-item"
                                    element={<CreateSupplierItemAssociation />}
                                />
                            ) : (
                                <Route
                                    path="/create-supplier-item"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("supplier_item_update") ? (
                                <Route
                                    path="/edit-supplier-item"
                                    element={<EditSupplierItemAssociation />}
                                />
                            ) : (
                                <Route
                                    path="/edit-supplier-item"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("bo_retrieve") ? (
                                <Route path="/bo" element={<BO />} />
                            ) : (
                                <Route path="/bo" element={<NotFound />} />
                            )}
                            {privileges.includes("bo_create") ? (
                                <Route
                                    path="/create-bo"
                                    element={<CreateBO />}
                                />
                            ) : (
                                <Route
                                    path="/create-bo"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("bo_update") ? (
                                <Route path="/edit-bo" element={<EditBO />} />
                            ) : (
                                <Route path="/edit-bo" element={<NotFound />} />
                            )}
                            {privileges.includes("operator_retrieve") ? (
                                <Route
                                    path="/operator"
                                    element={<Operator />}
                                />
                            ) : (
                                <Route
                                    path="/operator"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("operator_create") ? (
                                <Route
                                    path="/create-operator"
                                    element={<CreateOperator />}
                                />
                            ) : (
                                <Route
                                    path="/create-operator"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("operator_update") ? (
                                <Route
                                    path="/edit-operator"
                                    element={<EditOperator />}
                                />
                            ) : (
                                <Route
                                    path="/edit-operator"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("sampling_plan_retrieve") ? (
                                <Route
                                    path="/sampling-plan"
                                    element={<SamplingPlan />}
                                />
                            ) : (
                                <Route
                                    path="/sampling-plan"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("sampling_plan_create") ? (
                                <Route
                                    path="/create-sampling-plan"
                                    element={<CreateSamplingPlan />}
                                />
                            ) : (
                                <Route
                                    path="/create-sampling-plan"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("sampling_plan_update") ? (
                                <Route
                                    path="/edit-sampling-plan"
                                    element={<EditSamplingPlan />}
                                />
                            ) : (
                                <Route
                                    path="/edit-sampling-plan"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("item_parameter_retrieve") ? (
                                <Route
                                    path="/item-parameter"
                                    element={<ItemParameterAssociation />}
                                />
                            ) : (
                                <Route
                                    path="/item-parameter"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("item_parameter_create") ? (
                                <Route
                                    path="/create-item-parameter"
                                    element={<CreateItemParameterAssociation />}
                                />
                            ) : (
                                <Route
                                    path="/create-item-parameter"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("item_parameter_update") ? (
                                <Route
                                    path="/edit-item-parameter"
                                    element={<EditItemParameterAssociation />}
                                />
                            ) : (
                                <Route
                                    path="/edit-item-parameter"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes(
                                "daily_production_retrieve"
                            ) ? (
                                <Route
                                    path="/daily-production-report"
                                    element={<DailyProductionReport />}
                                />
                            ) : (
                                <Route
                                    path="/daily-production-report"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("daily_production_create") ? (
                                <Route
                                    path="/create-daily-production-report"
                                    element={<CreateDailyProductionReport />}
                                />
                            ) : (
                                <Route
                                    path="/create-daily-production-report"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("daily_production_update") ? (
                                <Route
                                    path="/edit-daily-production-report"
                                    element={<EditDailyProductionReport />}
                                />
                            ) : (
                                <Route
                                    path="/edit-daily-production-report"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("machine_status_retrieve") ? (
                                <Route
                                    path="/machine-status"
                                    element={<MachineStatus />}
                                />
                            ) : (
                                <Route
                                    path="/machine-status"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("machine_status_retrieve") ? (
                                <Route
                                    path="/machine-details"
                                    element={<MachineDetailedStatus />}
                                />
                            ) : (
                                <Route
                                    path="/machine-details"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("machine_status_create") ? (
                                <Route
                                    path="/create-machine-status"
                                    element={<CreateMachineStatus />}
                                />
                            ) : (
                                <Route
                                    path="/create-machine-status"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("machine_status_update") ? (
                                <Route
                                    path="/edit-machine-status"
                                    element={<EditMachineStatus />}
                                />
                            ) : (
                                <Route
                                    path="/edit-machine-status"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("quality_check_retrieve") ? (
                                <Route
                                    path="/quality-check"
                                    element={<QualityCheckResults />}
                                />
                            ) : (
                                <Route
                                    path="/quality-check"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("quality_check_create") ? (
                                <Route
                                    path="/create-quality-check"
                                    element={<CreateQualityCheckResults />}
                                />
                            ) : (
                                <Route
                                    path="/create-quality-check"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("quality_check_update") ? (
                                <Route
                                    path="/edit-quality-check"
                                    element={<EditQualityCheckResults />}
                                />
                            ) : (
                                <Route
                                    path="/edit-quality-check"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("quality_rules_retrieve") ? (
                                <Route
                                    path="/quality-rules"
                                    element={<QualityRules />}
                                />
                            ) : (
                                <Route
                                    path="/quality-rules"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("quality_rules_create") ? (
                                <Route
                                    path="/create-quality-rules"
                                    element={<CreateQualityRules />}
                                />
                            ) : (
                                <Route
                                    path="/create-quality-rules"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("quality_rules_update") ? (
                                <Route
                                    path="/edit-quality-rules"
                                    element={<EditQualityRules />}
                                />
                            ) : (
                                <Route
                                    path="/edit-quality-rules"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes(
                                "quality_parameter_retrieve"
                            ) ? (
                                <Route
                                    path="/quality-parameter"
                                    element={<QualityParameter />}
                                />
                            ) : (
                                <Route
                                    path="/quality-parameter"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("quality_parameter_create") ? (
                                <Route
                                    path="/create-quality-parameter"
                                    element={<CreateQualityParameter />}
                                />
                            ) : (
                                <Route
                                    path="/create-quality-parameter"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("quality_parameter_update") ? (
                                <Route
                                    path="/edit-quality-parameter"
                                    element={<EditQualityParameter />}
                                />
                            ) : (
                                <Route
                                    path="/edit-quality-parameter"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes(
                                "quality_rule_association_retrieve"
                            ) ? (
                                <Route
                                    path="/quality-rule-association"
                                    element={<QualityRuleAssociation />}
                                />
                            ) : (
                                <Route
                                    path="/quality-rule-association"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes(
                                "quality_rule_association_create"
                            ) ? (
                                <Route
                                    path="/create-quality-rule-association"
                                    element={<CreateQualityRuleAssociation />}
                                />
                            ) : (
                                <Route
                                    path="/create-quality-rule-association"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes(
                                "quality_rule_association_update"
                            ) ? (
                                <Route
                                    path="/edit-quality-rule-association"
                                    element={<EditQualityRuleAssociation />}
                                />
                            ) : (
                                <Route
                                    path="/edit-quality-rule-association"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes(
                                "stock_transaction_retrieve"
                            ) ? (
                                <Route
                                    path="/stock-transaction"
                                    element={<StockTransaction />}
                                />
                            ) : (
                                <Route
                                    path="/stock-transaction"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes(
                                "stock_transaction_retrieve"
                            ) ? (
                                <Route
                                    path="/stock-ledger"
                                    element={<StockLedger />}
                                />
                            ) : (
                                <Route
                                    path="/stock-ledger"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("stock_onboarding_import") ? (
                                <Route
                                    path="/stock-onboarding"
                                    element={<StockOnboarding />}
                                />
                            ) : (
                                <Route
                                    path="/stock-onboarding"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("stock_transaction_retrieve") ? (
                                <Route
                                    path="/create-stock-transaction"
                                    element={<StockTransaction />}
                                />
                            ) : (
                                <Route
                                    path="/create-stock-transaction"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("stock_transaction_retrieve") ? (
                                <Route
                                    path="/edit-stock-transaction"
                                    element={<StockTransaction />}
                                />
                            ) : (
                                <Route
                                    path="/edit-stock-transaction"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("role_retrieve") ? (
                                <Route path="/role" element={<Role />} />
                            ) : (
                                <Route path="/role" element={<NotFound />} />
                            )}
                            {privileges.includes("role_create") ? (
                                <Route
                                    path="/create-role"
                                    element={<CreateRole />}
                                />
                            ) : (
                                <Route
                                    path="/create-role"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("role_update") ? (
                                <Route
                                    path="/edit-role"
                                    element={<EditRole />}
                                />
                            ) : (
                                <Route
                                    path="/edit-role"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("privilege_retrieve") ? (
                                <Route
                                    path="/privilege"
                                    element={<Privilege />}
                                />
                            ) : (
                                <Route
                                    path="/privilege"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("privilege_create") ? (
                                <Route
                                    path="/create-privilege"
                                    element={<CreatePrivilege />}
                                />
                            ) : (
                                <Route
                                    path="/create-privilege"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("privilege_update") ? (
                                <Route
                                    path="/edit-privilege"
                                    element={<EditPrivilege />}
                                />
                            ) : (
                                <Route
                                    path="/edit-privilege"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("rv_matrix") ? (
                                <Route
                                    path="/rv-matrix"
                                    element={<RVMatrix />}
                                />
                            ) : (
                                <Route path="/role" element={<NotFound />} />
                            )}
                            {privileges.includes("type_master_retrieve") ? (
                                <Route
                                    path="/type-master"
                                    element={<TypeMaster />}
                                />
                            ) : (
                                <Route
                                    path="/type-master"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("type_master_create") ? (
                                <Route
                                    path="/create-type-master"
                                    element={<CreateTypeMaster />}
                                />
                            ) : (
                                <Route
                                    path="/create-type-master"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("type_master_update") ? (
                                <Route
                                    path="/edit-type-master"
                                    element={<EditTypeMaster />}
                                />
                            ) : (
                                <Route
                                    path="/edit-type-master"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes(
                                "type_master_category_retrieve"
                            ) ? (
                                <Route
                                    path="/type-master-category"
                                    element={<TypeMasterCategory />}
                                />
                            ) : (
                                <Route
                                    path="/type-master-category"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes(
                                "type_master_category_create"
                            ) ? (
                                <Route
                                    path="/create-type-master-category"
                                    element={<CreateTypeMasterCategory />}
                                />
                            ) : (
                                <Route
                                    path="/create-type-master-category"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes(
                                "type_master_category_update"
                            ) ? (
                                <Route
                                    path="/edit-type-master-category"
                                    element={<EditTypeMasterCategory />}
                                />
                            ) : (
                                <Route
                                    path="/edit-type-master-category"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("rv_matrix_updated") ? (
                                <Route
                                    path="/updated-rv-matrix"
                                    element={<UpdatedRVMatrix />}
                                />
                            ) : (
                                <Route
                                    path="/updated-rv-matrix"
                                    element={<NotFound />}
                                />
                            )}

                            {privileges.includes("rv_matrix_analytics") ? (
                                <Route
                                    path="/rv-analytics"
                                    element={<RVAnalytics />}
                                />
                            ) : (
                                <Route
                                    path="/rv-analytics"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("batch_insights") ? (
                                <Route
                                    path="/batch-insights"
                                    element={<BatchInsights />}
                                />
                            ) : (
                                <Route
                                    path="/batch-insights"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes(
                                "machine_operator_association"
                            ) ? (
                                <Route
                                    path="/machine-operator-association"
                                    element={<MachineOperatorAssociation />}
                                />
                            ) : (
                                <Route
                                    path="/machine-operator-association"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("machine_dashboard") ? (
                                <Route
                                    path="/machine-dashboard"
                                    element={<MachineDashboard />}
                                />
                            ) : (
                                <Route
                                    path="/machine-dashboard"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("qc-details") ? (
                                <Route
                                    path="/qc-details"
                                    element={<QCDetails />}
                                />
                            ) : (
                                <Route
                                    path="/qc-details"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("simulate_bom") ? (
                                <Route
                                    path="/simulate-bom"
                                    element={<SimulateBOM />}
                                />
                            ) : (
                                <Route
                                    path="/simulate-bom"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("sales_order_insights") ? (
                                <Route
                                    path="/sales-order-insights"
                                    element={<SalesOrderInsights />}
                                />
                            ) : (
                                <Route
                                    path="/sales-order-insights"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("dispatch_details") ? (
                                <Route
                                    path="/dispatch-details"
                                    element={<DispatchDetails />}
                                />
                            ) : (
                                <Route
                                    path="/dispatch-details"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("store_dept_slip_update") ? (
                                <Route
                                    path="/issue-stock"
                                    element={<RaiseRequisitionStoreView />}
                                />
                            ) : (
                                <Route
                                    path="/issue-stock"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("store_dept_slip_update") ? (
                                <Route
                                    path="/issue-slip-store"
                                    element={<IssueSlipStore />}
                                />
                            ) : (
                                <Route
                                    path="/issue-slip-store"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("returned_slip") ? (
                                <Route
                                    path="/return-slip"
                                    element={<ReturnedSlipTable />}
                                />
                            ) : (
                                <Route
                                    path="/return-slip"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("view_returned_slip") ? (
                                <Route
                                    path="/return-slip-details"
                                    element={<ReturnedSlipDetails />}
                                />
                            ) : (
                                <Route
                                    path="/return-slip-details"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes(
                                "sales_order_insights_detail"
                            ) ? (
                                <Route
                                    path="/sales-order-insights-detail"
                                    element={<SalesOrderInsightsDetails />}
                                />
                            ) : (
                                <Route
                                    path="/sales-order-insights-detail"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("batch_insights_detail") ? (
                                <Route
                                    path="/batch-insights-detail"
                                    element={<BatchInsightsDetails />}
                                />
                            ) : (
                                <Route
                                    path="/batch-insights-detail"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes(
                                "machine_dashboard_support"
                            ) ? (
                                <Route
                                    path="/machine-dashboard-support"
                                    element={<SupportDashboard />}
                                />
                            ) : (
                                <Route
                                    path="/machine-dashboard-support"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes(
                                "power_consumption_dashboard"
                            ) ? (
                                <Route
                                    path="/power-consumption-dashboard"
                                    element={<PowerConsumptionDashbarod />}
                                />
                            ) : (
                                <Route
                                    path="/power-consumption-dashboard"
                                    element={<NotFound />}
                                />
                            )}
                            {canViewBridgeConsole ? (
                                <Route
                                    path="/bridge-console"
                                    element={<BridgeConsole />}
                                />
                            ) : (
                                <Route
                                    path="/bridge-console"
                                    element={<NotFound />}
                                />
                            )}
                            {canViewNotificationConsole ? (
                                <Route
                                    path="/notification-console"
                                    element={<NotificationConsole />}
                                />
                            ) : (
                                <Route
                                    path="/notification-console"
                                    element={<NotFound />}
                                />
                            )}
                            {privileges.includes("reports") ? (
                                <Route
                                    path="/reports"
                                    element={<Reports />}
                                />
                            ) : (
                                <Route
                                    path="/reports"
                                    element={<NotFound />}
                                />
                            )}
                            {canViewLiveSite ? (
                                <Route
                                    path="/live-site"
                                    element={<LiveSite />}
                                />
                            ) : (
                                <Route
                                    path="/live-site"
                                    element={<NotFound />}
                                />
                            )}
                            {canViewTestCases ? (
                                <Route
                                    path="/test-cases"
                                    element={<TestCases />}
                                />
                            ) : (
                                <Route
                                    path="/test-cases"
                                    element={<NotFound />}
                                />
                            )}
                            {canViewOnsiteIssues ? (
                                <>
                                    <Route
                                        path="/create-onsite-issue"
                                        element={<CreateOnsiteIssue />}
                                    />
                                    <Route
                                        path="/edit-onsite-issue"
                                        element={<EditOnsiteIssue />}
                                    />
                                    <Route
                                        path="/onsite-issue-list"
                                        element={<OnsiteIssueList />}
                                    />
                                    <Route
                                        path="/onsite-issues"
                                        element={<OnsiteIssueMachines />}
                                    />
                                </>
                            ) : (
                                <Route
                                    path="/onsite-issues"
                                    element={<NotFound />}
                                />
                            )}
                            {canViewFloorData ? (
                                <Route
                                    path="/floor-data"
                                    element={<FloorData />}
                                />
                            ) : (
                                <Route
                                    path="/floor-data"
                                    element={<NotFound />}
                                />
                            )}
                            <Route path="/not-found" element={<NotFound />} />
                            <Route path="*" element={<Error />} />
                        </Routes>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Content;
